import * as api from '../api/funnel';
import { funnelStepFilterActions } from '../constants/filter';
import { asyncAction } from './common';

export const selectFunnel = (funnel) => ({
  type: 'SELECT_FUNNEL',
  funnel,
});

export const setFunnelExposureError = (error) => ({
  type: 'SET_FUNNEL_EXPOSE_ERROR',
  error,
});

export const startUpdateFunnel = (funnel = null) => ({
  type: 'START_UPDATE_FUNNEL',
  funnel,
});

export const setFunnelName = (name) => ({
  type: 'UPDATE_SET_FUNNEL_NAME',
  name,
});

export const cancelUpdateFunnel = () => ({
  type: 'CANCEL_UPDATE_FUNNEL',
});

export const addFunnelStep = () => ({
  type: 'UPDATE_FUNNEL_ADD_STEP',
});

export const changeFunnelStepPosition = (oldIndex, newIndex) => ({
  type: 'UPDATE_FUNNEL_CHANGE_STEP_POSITION',
  oldIndex,
  newIndex,
});

export const setFunnelStepEventName = (stepIndex, event) => ({
  type: 'UPDATE_FUNNEL_SET_EVENT_NAME',
  stepIndex,
  event,
});

export const toggleFunnelEnabled = (stepIndex) => ({
  type: 'UPDATE_TOGGLE_FUNNEL_ENABLED',
  stepIndex,
});

export const setFunnelStepOptionalStatus = (stepIndex, status) => ({
  type: 'UPDATE_FUNNEL_SET_STEP_OPTIONAL_STATUS',
  status,
  stepIndex,
});

export const setFunnelStepCount = (stepIndex, count, operator) => ({
  type: 'UPDATE_FUNNEL_SET_STEP_COUNT',
  count,
  operator,
  stepIndex,
});

export const setFunnelStepClosingRange = (stepIndex, closingRange) => ({
  type: 'UPDATE_FUNNEL_SET_STEP_CLOSING_RANGE',
  stepIndex,
  closingRange,
});

export const removeFunnelStep = (stepIndex) => ({
  type: 'UPDATE_REMOVE_FUNNEL_STEP',
  stepIndex,
});

export const setFunnelGlobalClosingRage = (closingRange) => ({
  type: 'UPDATE_FUNNEL_SET_GLOBAL_CLOSING_RANGE',
  closingRange,
});

export const addFilterClause = (stepIndex) => ({
  type: funnelStepFilterActions.ADD_FILTER_CLAUSE,
  stepIndex,
});

export const removeFilterClause = (stepIndex, id) => ({
  type: funnelStepFilterActions.REMOVE_FILTER_CLAUSE,
  id,
  stepIndex,
});

export const setFilterClauseField = (stepIndex, id, field, type) => ({
  type: funnelStepFilterActions.SET_FILTER_CLAUSE_FIELD,
  id,
  field,
  stepIndex,
  fieldType: type,
});

export const setFilterClauseValue = (stepIndex, id, value) => ({
  type: funnelStepFilterActions.SET_FILTER_CLAUSE_VALUE,
  id,
  value,
  stepIndex,
});

export const setClausesConcatOperator = (stepIndex, value) => ({
  type: funnelStepFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  value,
  stepIndex,
});

export const setFilterClauseOperator = (stepIndex, id, value, resetClauseValue) => ({
  type: funnelStepFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  id,
  value,
  resetClauseValue,
  stepIndex,
});

export const setFunnelFilterValue = (value) => ({
  type: 'FUNNEL_FILTER_VALUE_CHANGED',
  filterValue: value,
});

export const setFunnelSideListContainerWidth = (containerWidth) => ({
  type: 'SET_FUNNEL_SIDE_LIST_CONTAINER_WIDTH',
  containerWidth,
});

export const setConversionInterval = (conversionInterval) => ({
  type: 'SET_CONVERSION_INTERVAL',
  conversionInterval,
});

export const duplicateFunnel = (item) => ({
  type: 'FUNNEL_SELECT_DUPLICATE_FUNNEL',
  item,
});

export const changeFunnelView = (view) => ({
  type: 'CHANGE_FUNNEL_VIEW',
  view,
});

export const setFunnelExecuteId = (executeId) => ({
  type: 'SET_FUNNEL_EXECUTE_ID',
  executeId,
});

export const executeFunnel = (executeId) =>
  asyncAction('EXECUTE_FUNNEL', api.executeFunnelQuery(executeId));

export const exposeFunnelQuery = () => asyncAction('EXPOSE_FUNNEL_QUERY', api.exposeFunnelQuery());

export const fetchFunnels = () => asyncAction('FETCH_FUNNELS', api.getFunnels());

export const createFunnel = (funnel) => asyncAction('UPDATE_FUNNEL', api.createFunnel(funnel));

export const updateFunnel = (funnel, id) =>
  asyncAction('UPDATE_FUNNEL', api.updateFunnel(funnel, id));

export const deleteFunnel = (id) => asyncAction('DELETE_FUNNEL', api.deleteFunnel(id));
